var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"width":"44","height":"28","viewBox":"0 0 44 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"},domProps:{"innerHTML":_vm._s(_vm.value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }